export function parseIsothermTabularReport(blocks) {
  const isotherm = {};
  for (let block of blocks) {
    let submatrix = block['Isotherm Tabular Report'];
    if (!submatrix) continue;

    let headers = [];
    for (let row of submatrix) {
      if (row[0] && row[1]) {
        headers = row;
        break;
      }
    }
    isotherm.variables = {
      p: {
        data: [],
        label: headers[1].replace(/(.*) \((.*)\)/, '$1'),
        units: headers[1].replace(/(.*) \((.*)\)/, '$2'),
      },
      x: {
        data: [],
        label: headers[0].replace(/(.*) \((.*)\)/, '$1'),
        units: headers[0].replace(/(.*) \((.*)\)/, '$2'),
      },
      y: {
        data: [],
        label: headers[2].replace(/(.*) \((.*)\)/, '$1'),
        units: headers[2].replace(/(.*) \((.*)\)/, '$2'),
      },
    };

    for (let row of submatrix) {
      if (!isNaN(row[0]) && !isNaN(row[1]) && !isNaN(row[2])) {
        isotherm.variables.x.data.push(Number(row[0]));
        isotherm.variables.p.data.push(Number(row[1]));
        isotherm.variables.y.data.push(Number(row[2]));
      }
    }
  }
  return isotherm;
}
